import { render, staticRenderFns } from "./ResponseSection.vue?vue&type=template&id=0fd1aa0f&scoped=true&"
import script from "./ResponseSection.vue?vue&type=script&lang=js&"
export * from "./ResponseSection.vue?vue&type=script&lang=js&"
import style0 from "./ResponseSection.vue?vue&type=style&index=0&id=0fd1aa0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1aa0f",
  null
  
)

export default component.exports